import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const VisitCardSkeletonLoader = ({
  shouldEnableAnimation = false,
  skeletonHeight = 16,
  skeletonStatusWidth = '30%',
  skeletonSiteNameWidth = '70%',
  skeletonDateWidth = '50%',
  skeletonLabelWidth = '30%',
  skeletonValueWidth = '50%',
}) => {
  return (
    <div className="max-w-74 bg-vamos-white shadow-vamos-shadow rounded-10px p-4 border-2 border-vamos-white w-full">
      {/* Status */}
      <Skeleton height={skeletonHeight} width={skeletonStatusWidth} className="mb-6" enableAnimation={shouldEnableAnimation} />

      {/* Site Name */}
      <Skeleton height={skeletonHeight + 4} width={skeletonSiteNameWidth} className="mb-4" enableAnimation={shouldEnableAnimation} />

      {/* Date */}
      <Skeleton height={skeletonHeight} width={skeletonDateWidth} className="mb-6" enableAnimation={shouldEnableAnimation} />

      {/* Details Section */}
      <div className="grid gap-1 pb-8">
        <div className="flex justify-between items-center">
          <Skeleton height={skeletonHeight} width={skeletonLabelWidth} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          <Skeleton height={skeletonHeight} width={skeletonValueWidth} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
        </div>
        <div className="flex justify-between">
          <Skeleton height={skeletonHeight} width={skeletonLabelWidth} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          <Skeleton height={skeletonHeight} width={skeletonValueWidth} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
        </div>
        <div className="flex justify-between">
          <Skeleton height={skeletonHeight} width={skeletonLabelWidth} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          <Skeleton height={skeletonHeight} width="20%" containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
        </div>
        <div className="flex justify-between">
          <Skeleton height={skeletonHeight} width={skeletonLabelWidth} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          <Skeleton height={skeletonHeight} width="20%" containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
        </div>
      </div>
    </div>
  );
};

VisitCardSkeletonLoader.propTypes = {
  shouldEnableAnimation: PropTypes.bool,
  skeletonHeight: PropTypes.number,
  skeletonStatusWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonSiteNameWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonDateWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonLabelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonValueWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default VisitCardSkeletonLoader;
